module.exports = __webpack_public_path__ + "media/images/joc-logo-d2185e3d1c83113b9ae509505bbe1a89.png";